<template>
    <div class="block-editor create-ticket">
        <div class="wrapper">
            <section>
                <div class="editor-row-title">Contact ID</div>
                <TiptapEditor placeholder="Contact" v-model="clone.contactId" automation-mode />
            </section>
            <section>
                <div class="title">Subject</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        placeholder="Type Ticket Subject"
                        :show-attributes="true"
                        :show-emoji="true"
                        :max-character-count="1024"
                        v-model="clone.subject"
                    />
                </div>
            </section>
            <section>
                <div class="title">Contact Email Address</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        placeholder="Type contact email address or use attribute"
                        :show-attributes="true"
                        :show-emoji="false"
                        :max-character-count="400"
                        v-model="clone.email"
                        automation-mode
                    />
                </div>
            </section>
            <section>
                <div class="title">Contact Phone Number</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        placeholder="Type contact phone number or use attribute"
                        :show-attributes="true"
                        :show-emoji="false"
                        :max-character-count="400"
                        v-model="clone.phone"
                        automation-mode
                    />
                </div>
            </section>
            <section>
                <div class="title">Ticket Tag</div>
                <div class="text-editor-wrapper">
                    <a-auto-complete
                        v-model="clone.tag"
                        :data-source="tagList"
                        placeholder="Select or Create a Ticket Tag"
                        @select="onSelect"
                        @search="onSearch"
                        @change="onChange"
                        class="w-100"
                    />
                </div>
            </section>
            <section>
                <div class="title">Ticket Message</div>
                <TiptapEditor placeholder="Ticket Message" v-model="clone.message" automation-mode />
            </section>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import { CHATBOT_API } from "../../../../../../api/chatbotv2";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("CreateTicket");
export default {
    name: "CreateTicket",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            preDefinedTagFilters: ["chatbot", "offline_message", "automation", "other"],
            tagList: [],
        };
    },
    methods: {
        onSearch(searchText) {
            log("onSearch", searchText);
            this.tagList = !searchText ? this.preDefinedTagFilters : [searchText, ...this.preDefinedTagFilters];
        },
        onSelect(value) {
            log("onSelect", value);
        },
        onChange(value) {
            log("onChange", value);
        },
        fetchTicketTags() {
            CHATBOT_API.getAllChatBotTicketTags().then((res) => {
                this.preDefinedTagFilters = _.uniq(["chatbot", "offline_message", "automation", "other", ...res.data]);
                this.tagList = this.preDefinedTagFilters;
            });
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.create-ticket {
    section {
        margin-bottom: 10px;
    }

    .wrapper {
        padding: 30px;

        .title {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }
    }
}
</style>
